import utils from '@/utils';
import { clone } from '@/utils/dataUtil';
import { STRUCTURES_API } from '@/api';

const state = {
  tableKey: -999,
  currentTableRow: null,
  tableData: [],
  tableConfig: {
    columns: [{
      prop: 'versionId', label: 'Version', sortable: true,
    }, {
      prop: 'shortName', label: 'Name', sortable: true,
    }, {
      prop: 'description', label: 'Description', sortable: true,
    }, {
      prop: 'marketName', label: 'Market', sortable: true,
    }, {
      prop: 'createdBy', label: 'Created By', sortable: true,
    }, {
      prop: 'createdDate', label: 'Created Date', sortable: true, dataType: 'datetime',
    }, {
      prop: 'updatedBy', label: 'Updated By', sortable: true,
    }, {
      prop: 'updatedDate', label: 'Updated Date', sortable: true, dataType: 'datetime',
    }],
  },
  nullTableRow: {
    id: -999,
    versionId: null,
    shortName: null,
    description: null,
    commodityName: 'POWER',
    marketName: null,
    activeFlag: true,
    createdBy: null,
    createdDate: null,
    updatedBy: null,
    updatedDate: null,
  },
};

const getters = {
  getTableConfig: (state) => state.tableConfig,
  getTableData: (state) => state.tableData,
  getCurrentRow: (state) => state.currentTableRow,
  getMarketList: (state, localGetters, rootState) => rootState.lookup.marketList,
};

const actions = {
  initialize({ commit, dispatch, state }) {
    dispatch('lookup/fetchMarketList', null, { root: true });
    dispatch('loadTableData');
  },
  resetTable({ dispatch, commit, state }) {
    commit('resetTable');
  },
  loadTableData({ commit }) {
    STRUCTURES_API.get('/market-trade-products').then(({ data }) => {
      commit('loadTableData', data.marketTradeProducts);
      this.$notify(`${data.marketTradeProducts.length} Market Trade Product(s) Loaded`, 'info');
    }).catch((err) => {
      this.$notify('Failed to Market Trade Product(s)', 'error');
    });
  },
  createTableRow({ commit }) {
    commit('createTableRow');
  },
  postMarketTradeProduct({ state }, tradeProduct) {
    STRUCTURES_API.post('/market-trade-products', tradeProduct).then(({ data }) => {
      state.tableData.push(data);
      this.$notify('Market Trade Product Added', 'success');
    }).catch((err) => {
      this.$notify('Failed to Add Market Trade Product', 'error');
    });
  },
  updateMarketTradeProduct({ dispatch, commit, state }, marketTradeProduct) {
    STRUCTURES_API.put(`/market-trade-products/${marketTradeProduct.id}`, marketTradeProduct).then(({ data }) => {
      commit('updateMarketTradeProduct', data);
      this.$notify('Market Trade Product Updated', 'success');
    }).catch((err) => {
      this.$notify('Failed to Update Market Trade Product', 'error');
    });
  },
  deleteTableRow({ dispatch, commit, state }) {
    STRUCTURES_API.delete(`/market-trade-products/${state.currentTableRow.id}`).then(({ data }) => {
      commit('deleteTableRow');
      dispatch('currentTableRowChange', clone(state.nullTableRow));
      this.$notify('Market Trade Product Removed', 'success');
    }).catch((err) => {
      this.$notify('Failed to Remove Market Trade Product', 'error');
    });
  },
  currentTableRowChange({ commit }, currentTableRow) {
    commit('currentTableRowChange', currentTableRow);
  },
};

const mutations = {
  updateMarketTradeProduct(state, marketTradeProduct) {
    const rowIndex = state.tableData.findIndex(({ id }) => id === marketTradeProduct.id);
    state.tableData.splice(rowIndex, 1, marketTradeProduct);
  },
  currentTableRowChange(state, currentRow) {
    state.currentTableRow = currentRow;
  },
  resetTable(state) {
    state.tableData = [];
    state.currentTableRow = clone(state.nullTableRow);
  },
  loadTableData(state, marketTradeProducts) {
    state.tableData = marketTradeProducts;
  },
  createTableRow(state) {
    const marketTradeProduct = clone(state.nullTableRow);
    marketTradeProduct.id = state.tableKey++;
    marketTradeProduct.versionId = 1;
    marketTradeProduct.createdBy = this.getters['auth/getProfile'].userName;
    marketTradeProduct.createdDate = utils.date.getNow().utc().format();
    state.currentTableRow = marketTradeProduct;
  },
  deleteTableRow(state) {
    state.tableData = state.tableData.filter((marketTradeProduct) => marketTradeProduct.id !== state.currentTableRow.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};